import { Language } from '@api/models';
import { makeStateKey, StateKey } from '@angular/core';
import type { TranslationObject } from '@ngx-translate/core';

export const makeLangStateKey = (lang: Language): StateKey<TranslationObject> => {
  return makeStateKey<TranslationObject>(`transfer-translate-${lang}`);
};
